<div class="cropper" *ngIf="imageUrl" id="{{ componentObject | titleToId }}">
  <section class="page-head-new" *ngIf="component" [id]="component.uuid">
    <img class="page-head-new-bg" [ngSrc]="imageUrl | ssrEmptyString" [alt]="imageAlt" fill />
    <div class="custom-gradient" *ngIf="componentObject?.gradient"></div>
    <div class="wrapper top-wrapper">
      <h1 class="heading">
        <span *ngIf="title">{{ title }}</span>
        <span class="date-header" *ngIf="eventDateFrom">{{ dateLabel(eventDateFrom, eventDateTill) }}</span>
      </h1>
    </div>
  </section>
  <div class="container lead-extension">
    <div class="figure figure-{{ figureImage }}"></div>
    <div class="wrapper lead-wrapper figure-{{ figureImage }}-lead">
      <div class="text-box" *ngIf="text" [innerHtml]="shortenedLead"></div>
      <span *ngIf="showReadMore" class="more" (click)="onReadMore()">
        {{ 'TEXT.readMore' | translate }} <i class="icon icon-arrow-down-more-red"></i
      ></span>
      <span *ngIf="showReadLess" class="less" (click)="onReadLess()">
        {{ 'TEXT.readLess' | translate }} <i class="icon icon-arrow-down-more-red"></i
      ></span>
    </div>
  </div>
</div>
